import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from '@kempower-nx-workspace/ctep-event-log-app-core';
import { ctepEventLogShellRoutes } from '@kempower-nx-workspace/ctep-event-log-app-shell';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(ctepEventLogShellRoutes),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideAnimations(),
    ],
};
